import React from 'react';
import { useParams } from 'react-router-dom';
import { TeamMember } from '@marageti/z4-sdk/lib/people';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { TripMatch } from '@marageti/z4-sdk/lib/travel';
import { useSnackbar } from 'notistack';
import TripRequestAssignToBarView from './trip-request-assign-to-bar-view';
import { useAuthStore } from '../../store';
import useTripRequestAssignment from './use-trip-request-assignment';

const TripRequestAssignToBarContainer = () => {
  const { loggedInTeamMember } = useAuthStore();
  const { tripRequestId, tripMatchId } = useParams();
  const apiClient = useApiClient();
  const { enqueueSnackbar } = useSnackbar();

  let resolvedTripRequestId = tripRequestId;

  // If the tripRequestId is not available, use the tripMatchId to get the associated tripRequestId
  if (!tripRequestId && tripMatchId) {
    const tripMatch = useFetch<TripMatch>(apiClient.tripMatchesClient.getTripMatch, [tripMatchId], !!tripMatchId);
    resolvedTripRequestId = tripMatch.data?.tripRequestId;
  }

  const {
    teamMembers,
    tripRequest,
    assignToTeamMember,
    assignToSelf,
    unassign,
  } = useTripRequestAssignment({
    tripRequestId: resolvedTripRequestId,
  });

  const confirmUnassign = () => {
    unassign();
    enqueueSnackbar('Trip unassigned.', { variant: 'success' });
  };

  const confirmAssignToSelf = () => {
    assignToSelf();
    enqueueSnackbar('Trip assigned.', { variant: 'success' });
  };

  const confirmAssignToTeamMember = (teamMember: TeamMember) => {
    assignToTeamMember(teamMember);
    enqueueSnackbar('Trip assigned.', { variant: 'success' });
  };

  return (
    <TripRequestAssignToBarView
      isLoading={tripRequest.isLoading}
      isUnassigned={!tripRequest.data?.assignedTo}
      isAssignedToSelf={tripRequest.data?.assignedTo === loggedInTeamMember?.id}
      assignedToName={tripRequest.data?.assignedToName}
      onAssignToTeamMember={confirmAssignToTeamMember}
      onAssignToSelf={confirmAssignToSelf}
      onUnassign={confirmUnassign}
      teamMembers={teamMembers?.sort((a, b) => a.fullName.localeCompare(b.fullName)) || []}
    />
  );
};

export default TripRequestAssignToBarContainer;
